import { EnvelopeCheckIcon } from '@/assets';
import { BackdropImage } from '@/components/ui/backdropImage';
import { Button } from '@/components/ui/button';
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AuthContext } from '@/context/authContext';
import { routes } from '@/types/routes';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(forgot-password)/code-sent')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setUsername } = useContext(AuthContext);

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('forgotPassword.codeSent.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          { t('forgotPassword.codeSent.description', { ns: 'auth' }) }
        </CardDescription>
      </CardHeader>

      <CardContent className="pt-space-lg flex flex-col items-center">
        <BackdropImage src={ EnvelopeCheckIcon } className="mb-space-md" />

        <div className="grid gap-space-2xs w-full pt-space-md">
          <Button
            onClick={ () => {
              void navigate({ to: routes.resetPassword });
            } }
          >
            { t('buttons.enterCode', { ns: 'auth' }) }
          </Button>
          <Button
            variant="ghost"
            onClick={ () => {
              setUsername('');
              void navigate({ to: routes.forgotPassword });
            } }
          >
            { t('buttons.back') }
          </Button>
        </div>
      </CardContent>
    </>
  );
}
